const DEFAULT_CITY = "Dnipro";

export default DEFAULT_CITY;
